import './App.css';
import { lazy, Suspense, useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import HomePage from './pages/home';
import Layout from './components/layout';
import WorkPage from './pages/work';
import ProjectDetail from './pages/projectDetail';
import ContactPage from './pages/contact';
import StorePage from './pages/store';
import FineArtsDetailPage from './pages/fineArtDetail';
import { ContentProvider } from './content/ContentProvider';
import { USE_API } from './content/source';
import { captureLinkToken } from './admin/linkToken';

// The admin is loaded only when someone opens /admin.
const AdminApp = lazy(() => import('./admin'));

function App() {
  // Invitation and recovery links arrive with a one-time token in the
  // address. Take it out of the address bar before anything else runs.
  const [fromEmailLink] = useState(() => USE_API && captureLinkToken());
  const navigate = useNavigate();
  useEffect(() => {
    if (fromEmailLink) navigate('/admin/set-password', { replace: true });
    // Once, on arrival. `navigate` changes with every route change, and
    // running this again would send the owner back after signing in.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="col-12">
      <ContentProvider>
      <Routes>
        {USE_API && (
          <Route path="/admin/*" element={<Suspense fallback={null}><AdminApp /></Suspense>} />
        )}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />}/>
          <Route path="/work" element={<WorkPage />}/>
          <Route path="/fine-art" element={<StorePage />}/>
          <Route path="/contact" element={<ContactPage />}/>
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/fine-arts/:id" element={<FineArtsDetailPage />} />
        </Route>
      </Routes>
      </ContentProvider>
    </div>
  );
}

export default App;
